<template>
    <div>
    <span class="Maintitle"> 
    <h4><small class="text-muted">
             <i class="fas fa-envelope"></i> <strong> Contact Us : </strong> 
           
    </small></h4>  
    </span> 
    <!-- <span class="Maintitle">
    <i class="fas fa-clinic-medical"></i>
    <strong> Limited Access Exception Drug Status (EDS) Application </strong>
    </span> -->
    <Card>
      <CardBody>
           <!-- For information on Supplementary Health/Family Health policies, procedures, claims submission, registration for EDS contact: -->

            
        <div class="row mt-1">  
          <div class="col-12 col-lg-10">
            <TileCard>
              <template slot="header">For information regarding Exception Drug Status (EDS) policies and procedures for the Limited Access EDS Application (LAEA) contact: </template>
              <template slot="body">
                <address>
                  Toll free: <strong>1-800-667-2549 or 306-787-8744 (in Regina) </strong> <br> Hours:  Monday – Friday, 8 am to 5pm<hr>
                  Drug Plan and Extended Benefits Branch<br> Ministry of Health<br> 2nd floor - 3475 Albert Street<br> Regina, SK S4S 6X6<br>
                  <!-- Email: supphealth@health.gov.sk.ca<br> -->
                  <!-- <abbr title="Email">Email</abbr>: supphealth@health.gov.sk.ca<br> -->
                </address>
              </template>
            </TileCard>

            <TileCard>
              <template slot="header">For information regarding Prescription Claims submission or claims payments contact:</template>
              <template slot="body">
                <address>
                  Toll free: <strong>1-800-667-7581 or 306-787-3317 (in Regina) </strong> <br> Hours:  Monday – Friday, 8 am to 5pm<hr>
                  Drug Plan and Extended Benefits Branch<br> Ministry of Health<br> 2nd floor - 3475 Albert Street<br> Regina, SK S4S 6X6<br>
                  <!-- Email: supphealth@health.gov.sk.ca<br> -->
                  <!-- <abbr title="Email">Email</abbr>: supphealth@health.gov.sk.ca<br> -->
                </address>
              </template>
            </TileCard>


            <TileCard>
              <template slot="header">For issues with network connectivity (system down) contact:</template>
              <template slot="body">
                <address>
                  CGI HelpDesk (24/7 availability)<br>
                  <strong>1-800-667-6080<br> 306-761-4286</strong><br>
                  The following groups should indicate they require assistance with the Drug Plan and Extended Benefits Branch Limited Access EDS Application (the LAEA): <br>
                    1.	Participating community pharmacies <br>
                    2.  MS Drugs Program <br>
                    3.  SHA pharmacists <br>
                  <!-- <abbr title="Email">Email</abbr>: supphealth@health.gov.sk.ca<br> -->
                </address>
              </template>
            </TileCard>
          </div>
        </div>

      </CardBody>
        </Card>
</div>
</template>
<script>
import Card from "@/Common/Card.vue";
import CardBody from "@/Common/CardBody.vue";
import TileNote from "@/Common/TileNote.vue";
import TileCard from "@/Common/TileCard.vue";
import { mapGetters } from 'vuex';
export default  {
     props:{
        error:''
     }, //['ServiceID','msg', 'MenuArray','error'],
  data: function () {
      
    return {
 
        }
    },
    components: { 
              Card,
            CardBody,
            TileNote,
            TileCard           
        },
    mounted: function () {
    this.$nextTick(function () {  
    })
    },
    created: function() { 
        //this.$emit('update:layout', LoginLayout);
        ////console.log('at Dental Main home')
        //this.menuitems = this.$store.getters.GetMainMenu; 
    },
    computed:{
        ...mapGetters({
                GetMessage: 'GetMessage',
                ShowLoginMsg: 'ShowLoginMsg'
            }),
        errorMsg: {
           get(){
             return this.GetMessage
           },
           set(newName){
             return newName
           } 
        }, 
        ...mapGetters({
                 
                ShowLoginMsg: 'ShowLoginMsg'
            }),
        ShowMsg: {
           get(){
             return this.ShowLoginMsg
           },
           set(val){
             return val
           } 
        },
    },
    watch: {
    ShowMsg: function (val) {
        ////console.log (val)
        if(val)
        {
            //this.showMsg1("Seesion","","Con")
        }
        },
    },
    methods: {
    HideMsg: function(val){
        this.$store.dispatch('ResetLoginMSg');
        this.$bvModal.hide('modal-sm');
        },
    showMsg1(msg,data,Title) {
        this.boxTwo = ''
        this.$bvModal.msgBoxOk(msg, {
        title: Title,
        size: 'md',
        buttonSize: 'md',
        okVariant: 'primary',          
        okTitle: 'Close', 
        footerClass: 'p-2',
        hideHeaderClose: true,
        hideHeaderCancel: true,
        centered: true, 
        }); 
      }, 
    },
}
</script>
<style scoped>

</style>

